<template>
  <div class="zwx-screen" ref="zwxScreen" :style="screenStyles">
    <div class="wrap" :style="wrapStyles">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZwxScreen',
  props: {
    width: { type: Number, value: 0, default: 1920 },
    height: { type: Number, value: 0, default: 1080 },
    bg: { type: String, value: '#000', default: '#000' },
  },
  data() {
    return {
      screenWidth: this.width,
      screenHeight: this.height,
    }
  },
  computed: {
    screenStyles() {
      return `background: ${this.bg}`
    },
    wrapStyles() {
      return `width: ${this.width}px; height: ${this.height}px; margin-left: ${this.marginLeft}px; transform: translateZ(0) scale(${this.scale});`
    },
    marginLeft() {
      return (this.screenWidth - this.width * this.scale) / 2
    },
    isHeight() {
      return (this.width * this.screenHeight) / this.height < this.screenWidth
    },
    scale() {
      return this.isHeight ? this.screenHeight / this.height : this.screenWidth / this.width
    },
  },
  watch: {
    scale(scale) {
      this.$emit('scale', scale)
    },
  },
  mounted() {
    window.onresize = () => this.setScreen()
    this.setScreen()
  },
  methods: {
    setScreen() {
      this.screenWidth = this.$refs['zwxScreen'].offsetWidth
      this.screenHeight = this.$refs['zwxScreen'].offsetHeight
    },
  },
}
</script>

<style lang="less" scoped>
.zwx-screen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .wrap {
    left: 0;
    right: 0;
    top: 0;
    margin-top: auto;
    margin-right: auto;
    margin-bottom: auto;
    transform-origin: 0 0;
  }
}
</style>
